import type * as Types from '../base-types.graphql';

import { gql } from '@apollo/client';
export type GqlStripeAddressFieldsFragment = { city?: string | null, country?: string | null, line1?: string | null, line2?: string | null, postal_code?: string | null, state?: string | null };

export type GqlStripeCustomerFieldsFragment = { id: string, object: string, balance: number, created: number, currency?: string | null, default_source?: string | null, delinquent?: boolean | null, description?: string | null, discount?: any | null, email?: string | null, invoice_prefix?: string | null, livemode: boolean, metadata: any, name?: string | null, next_invoice_sequence?: number | null, phone?: string | null, preferred_locales?: Array<string> | null, shipping?: any | null, sources?: any | null, subscriptions?: any | null, tax_exempt?: string | null, tax_ids?: any | null, invoice_settings: { default_payment_method?: string | null } };

export type GqlStripeSubscriptionFieldsFragment = { id: string, object: string, application_fee_percent?: number | null, billing_cycle_anchor: number, billing_thresholds?: any | null, cancel_at?: number | null, cancel_at_period_end: boolean, canceled_at?: number | null, collection_method: string, created: number, current_period_end: number, current_period_start: number, customer: string, days_until_due?: number | null, default_payment_method?: string | null, default_source?: string | null, default_tax_rates?: any | null, ended_at?: number | null, latest_invoice?: string | null, livemode: boolean, metadata: any, next_pending_invoice_item_invoice?: number | null, pause_collection?: any | null, pending_invoice_item_interval?: any | null, pending_setup_intent?: string | null, pending_update?: any | null, schedule?: string | null, start_date: number, status: Types.GqlStripeSubscriptionStatus, transfer_data?: any | null, trial_end?: number | null, trial_start?: number | null, discount?: { id: string, object: string, start: number, end?: number | null, customer?: string | null, invoice?: string | null, invoice_item?: string | null, subscription?: string | null, coupon: { id: string, object: string, name?: string | null, currency?: string | null, amount_off?: number | null, percent_off?: number | null, applies_to?: { products: Array<string> } | null } } | null, items: { has_more: boolean, url: string, data: Array<{ id: string, object: string, billing_thresholds?: any | null, created: number, metadata: any, plan: any, quantity?: any | null, subscription: any, tax_rates?: any | null, price: { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null } }> }, subscriptionItems: Array<{ id: string, object: string, billing_thresholds?: any | null, created: number, metadata: any, plan: any, quantity?: any | null, subscription: any, tax_rates?: any | null, price: { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null } }> };

export type GqlStripeSubscriptionItemFieldsFragment = { id: string, object: string, billing_thresholds?: any | null, created: number, metadata: any, plan: any, quantity?: any | null, subscription: any, tax_rates?: any | null, price: { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null } };

export type GqlStripePromotionCodeFieldsFragment = { active: boolean, code: string, id: string, object: string };

export type GqlStripeUpcomingInvoiceFieldsFragment = { account_country?: string | null, account_name?: string | null, amount_due: number, amount_paid: number, amount_remaining: number, application?: string | null, application_fee_amount?: number | null, attempt_count: number, attempted: boolean, auto_advance?: boolean | null, created: number, currency: string, customer?: string | null, customer_email?: string | null, customer_name?: string | null, customer_phone?: string | null, description?: string | null, due_date?: number | null, ending_balance?: number | null, footer?: string | null, hosted_invoice_url?: string | null, invoice_pdf?: string | null, last_finalization_error?: any | null, livemode: boolean, metadata?: any | null, next_payment_attempt?: number | null, number?: string | null, object: string, paid: boolean, paid_out_of_band: boolean, period_end: number, period_start: number, post_payment_credit_notes_amount: number, pre_payment_credit_notes_amount: number, quote?: string | null, receipt_number?: string | null, starting_balance: number, statement_descriptor?: string | null, status?: string | null, status_transitions: any, subscription?: string | null, subscription_proration_date?: number | null, subtotal: number, tax?: number | null, total: number, webhooks_delivered_at?: number | null };

export type GqlStripeInvoiceFieldsFragment = { id: string, account_country?: string | null, account_name?: string | null, amount_due: number, amount_paid: number, amount_remaining: number, application?: string | null, application_fee_amount?: number | null, attempt_count: number, attempted: boolean, auto_advance?: boolean | null, created: number, currency: string, customer?: string | null, customer_email?: string | null, customer_name?: string | null, customer_phone?: string | null, description?: string | null, due_date?: number | null, ending_balance?: number | null, footer?: string | null, hosted_invoice_url?: string | null, invoice_pdf?: string | null, last_finalization_error?: any | null, livemode: boolean, metadata?: any | null, next_payment_attempt?: number | null, number?: string | null, object: string, payment_intent?: string | null, paid: boolean, paid_out_of_band: boolean, period_end: number, period_start: number, post_payment_credit_notes_amount: number, pre_payment_credit_notes_amount: number, quote?: string | null, receipt_number?: string | null, starting_balance: number, statement_descriptor?: string | null, status?: Types.GqlStripeInvoiceStatus | null, subscription?: string | null, subscription_proration_date?: number | null, subtotal: number, tax?: number | null, total: number, webhooks_delivered_at?: number | null, status_transitions: { marked_uncollectible_at?: number | null, paid_at?: number | null, voided_at?: number | null, finalized_at?: number | null } };

export type GqlStripePaymentIntentFieldsFragment = { id: string, object: string, source?: string | null, amount: number, amount_capturable: number, amount_details: any, amount_received: number, application?: string | null, application_fee_amount?: number | null, automatic_payment_methods?: any | null, canceled_at?: number | null, cancellation_reason?: string | null, capture_method: string, client_secret: string, confirmation_method: string, created: number, currency: string, customer: string, description: string, invoice?: string | null, last_payment_error?: any | null, latest_charge?: string | null, metadata: any, next_action?: any | null, on_behalf_of?: string | null, payment_method?: string | null, payment_method_options: any, payment_method_types: Array<string>, processing?: any | null, receipt_email?: string | null, review?: string | null, setup_future_usage?: string | null };

export type GqlStripeInvoiceLineItemFieldsFragment = { id?: string | null, object: string, amount: number, amount_excluding_tax?: number | null, unit_amount_excluding_tax?: string | null, currency: string, description?: string | null, discount_amounts?: any | null, discountable: boolean, discounts: any, invoice_item?: string | null, livemode: boolean, metadata: any, period: any, plan?: any | null, price?: any | null, proration: boolean, quantity?: number | null, subscription?: string | null, subscription_item?: string | null, tax_amounts?: any | null, tax_rates?: any | null, type: string };

export type GqlStripeQuoteFieldsFragment = { id: string, object: string, amount_subtotal: number, amount_total: number, application?: string | null, application_fee_amount?: number | null, application_fee_percent?: number | null, collection_method: string, created: number, currency?: string | null, customer?: string | null, default_tax_rates?: any | null, description?: string | null, discounts: any, expires_at: number, footer?: string | null, from_quote?: any | null, header?: string | null, invoice?: string | null, invoice_settings: any, livemode: boolean, metadata: any, number?: string | null, on_behalf_of?: string | null, status: string, status_transitions: any, subscription?: string | null, subscription_data: any, subscription_schedule?: string | null, transfer_data?: any | null, total_details: { amount_discount: number, amount_tax: number }, line_items?: { object: string, has_more: boolean, data: Array<{ id: string, object: string, amount_subtotal: number, amount_discount: number, amount_tax: number, amount_total: number, currency: string, description: string, discounts?: any | null, quantity?: number | null, taxes?: any | null, price?: { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null } | null }> } | null };

export type GqlStripeLineItemFieldsFragment = { id: string, object: string, amount_subtotal: number, amount_discount: number, amount_tax: number, amount_total: number, currency: string, description: string, discounts?: any | null, quantity?: number | null, taxes?: any | null, price?: { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null } | null };

export type GqlStripePmCardFieldsFragment = { brand: string, checks?: any | null, country?: string | null, description?: string | null, display_brand?: string | null, exp_month: number, exp_year: number, fingerprint?: string | null, funding: string, iin?: string | null, issuer?: string | null, last4: string, networks?: any | null, three_d_secure_usage?: any | null, wallet?: any | null };

export type GqlStripePaymentMethodFieldsFragment = { id: string, object: string, billing_details: any, created: number, customer?: string | null, livemode: boolean, metadata?: any | null, type: string };

export type GqlStripeCheckoutSessionFieldsFragment = { id: string, object: string, allow_promotion_codes?: boolean | null, amount_subtotal?: number | null, amount_total?: number | null, billing_address_collection?: string | null, cancel_url: string, client_reference_id?: string | null, currency?: string | null, customer?: string | null, customer_details?: any | null, customer_email?: string | null, line_items?: Array<any> | null, livemode: boolean, locale?: string | null, metadata?: any | null, mode: string, payment_intent?: string | null, payment_method_options?: any | null, payment_method_types: Array<string>, payment_status: string, setup_intent?: string | null, shipping_address_collection?: any | null, submit_type?: string | null, subscription?: string | null, success_url: string, total_details?: any | null };

export type GqlStripeProductFieldsFragment = { id: string, type: string, object: string, active: boolean, attributes?: any | null, caption?: string | null, created: number, deactivate_on?: any | null, description?: string | null, images: any, livemode: boolean, metadata: any, name: string, package_dimensions?: any | null, shippable?: boolean | null, statement_descriptor?: string | null, unit_label?: string | null, updated: number, url?: string | null };

export type GqlStripePriceFieldsFragment = { id: string, object: string, active: boolean, billing_scheme: string, created: number, currency: string, livemode: boolean, lookup_key?: string | null, nickname?: string | null, product: string, tiers?: any | null, tiers_mode?: string | null, transform_quantity?: any | null, type: string, unit_amount?: number | null, unit_amount_decimal?: string | null, recurring?: { aggregate_usage?: string | null, interval: Types.GqlStripeRecurringInterval, interval_count: number, trial_period_days?: number | null, usage_type: string } | null };

export type GqlStripeCouponFieldsFragment = { id: string, object: string, name?: string | null, currency?: string | null, amount_off?: number | null, percent_off?: number | null, applies_to?: { products: Array<string> } | null };

export type GqlStripeDiscountFieldsFragment = { id: string, object: string, start: number, end?: number | null, customer?: string | null, invoice?: string | null, invoice_item?: string | null, subscription?: string | null, coupon: { id: string, object: string, name?: string | null, currency?: string | null, amount_off?: number | null, percent_off?: number | null, applies_to?: { products: Array<string> } | null } };

export const StripeAddressFieldsFragmentDoc = gql`
    fragment StripeAddressFields on StripeAddress {
  city
  country
  line1
  line2
  postal_code
  state
}
    `;
export const StripeCustomerFieldsFragmentDoc = gql`
    fragment StripeCustomerFields on StripeCustomer {
  id
  object
  balance
  created
  currency
  default_source
  delinquent
  description
  discount
  email
  invoice_prefix
  invoice_settings {
    default_payment_method
  }
  livemode
  metadata
  name
  next_invoice_sequence
  phone
  preferred_locales
  shipping
  sources
  subscriptions
  tax_exempt
  tax_ids
}
    `;
export const StripeCouponFieldsFragmentDoc = gql`
    fragment StripeCouponFields on StripeCoupon {
  id
  object
  name
  currency
  amount_off
  percent_off
  applies_to {
    products
  }
}
    `;
export const StripeDiscountFieldsFragmentDoc = gql`
    fragment StripeDiscountFields on StripeDiscount {
  id
  object
  start
  end
  customer
  invoice
  invoice_item
  subscription
  coupon {
    ...StripeCouponFields
  }
}
    ${StripeCouponFieldsFragmentDoc}`;
export const StripePriceFieldsFragmentDoc = gql`
    fragment StripePriceFields on StripePrice {
  id
  object
  active
  billing_scheme
  created
  currency
  livemode
  lookup_key
  nickname
  product
  recurring {
    aggregate_usage
    interval
    interval_count
    trial_period_days
    usage_type
  }
  tiers
  tiers_mode
  transform_quantity
  type
  unit_amount
  unit_amount_decimal
}
    `;
export const StripeSubscriptionItemFieldsFragmentDoc = gql`
    fragment StripeSubscriptionItemFields on StripeSubscriptionItem {
  id
  object
  billing_thresholds
  created
  metadata
  plan
  price {
    ...StripePriceFields
  }
  quantity
  subscription
  tax_rates
}
    ${StripePriceFieldsFragmentDoc}`;
export const StripeSubscriptionFieldsFragmentDoc = gql`
    fragment StripeSubscriptionFields on StripeSubscription {
  id
  object
  application_fee_percent
  billing_cycle_anchor
  billing_thresholds
  cancel_at
  cancel_at_period_end
  canceled_at
  collection_method
  created
  current_period_end
  current_period_start
  customer
  days_until_due
  default_payment_method
  default_source
  default_tax_rates
  discount {
    ...StripeDiscountFields
  }
  ended_at
  items {
    data {
      ...StripeSubscriptionItemFields
    }
    has_more
    url
  }
  subscriptionItems {
    ...StripeSubscriptionItemFields
  }
  latest_invoice
  livemode
  metadata
  next_pending_invoice_item_invoice
  pause_collection
  pending_invoice_item_interval
  pending_setup_intent
  pending_update
  schedule
  start_date
  status
  transfer_data
  trial_end
  trial_start
}
    ${StripeDiscountFieldsFragmentDoc}
${StripeSubscriptionItemFieldsFragmentDoc}`;
export const StripePromotionCodeFieldsFragmentDoc = gql`
    fragment StripePromotionCodeFields on StripePromotionCode {
  active
  code
  id
  object
}
    `;
export const StripeUpcomingInvoiceFieldsFragmentDoc = gql`
    fragment StripeUpcomingInvoiceFields on StripeUpcomingInvoice {
  account_country
  account_name
  amount_due
  amount_paid
  amount_remaining
  application
  application_fee_amount
  attempt_count
  attempted
  auto_advance
  created
  currency
  customer
  customer_email
  customer_name
  customer_phone
  description
  due_date
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  last_finalization_error
  livemode
  metadata
  next_payment_attempt
  number
  object
  paid
  paid_out_of_band
  period_end
  period_start
  post_payment_credit_notes_amount
  pre_payment_credit_notes_amount
  quote
  receipt_number
  starting_balance
  statement_descriptor
  status
  status_transitions
  subscription
  subscription_proration_date
  subtotal
  tax
  total
  webhooks_delivered_at
}
    `;
export const StripeInvoiceFieldsFragmentDoc = gql`
    fragment StripeInvoiceFields on StripeInvoice {
  id
  account_country
  account_name
  amount_due
  amount_paid
  amount_remaining
  application
  application_fee_amount
  attempt_count
  attempted
  auto_advance
  created
  currency
  customer
  customer_email
  customer_name
  customer_phone
  description
  due_date
  ending_balance
  footer
  hosted_invoice_url
  invoice_pdf
  last_finalization_error
  livemode
  metadata
  next_payment_attempt
  number
  object
  payment_intent
  paid
  paid_out_of_band
  period_end
  period_start
  post_payment_credit_notes_amount
  pre_payment_credit_notes_amount
  quote
  receipt_number
  starting_balance
  statement_descriptor
  status
  status_transitions {
    marked_uncollectible_at
    paid_at
    voided_at
    finalized_at
  }
  subscription
  subscription_proration_date
  subtotal
  tax
  total
  webhooks_delivered_at
}
    `;
export const StripePaymentIntentFieldsFragmentDoc = gql`
    fragment StripePaymentIntentFields on StripePaymentIntent {
  id
  object
  source
  amount
  amount_capturable
  amount_details
  amount_received
  application
  application_fee_amount
  automatic_payment_methods
  canceled_at
  cancellation_reason
  capture_method
  client_secret
  confirmation_method
  created
  currency
  customer
  description
  invoice
  last_payment_error
  latest_charge
  metadata
  next_action
  on_behalf_of
  payment_method
  payment_method_options
  payment_method_types
  processing
  receipt_email
  review
  setup_future_usage
}
    `;
export const StripeInvoiceLineItemFieldsFragmentDoc = gql`
    fragment StripeInvoiceLineItemFields on StripeInvoiceLineItem {
  id
  object
  amount
  amount_excluding_tax
  unit_amount_excluding_tax
  currency
  description
  discount_amounts
  discountable
  discounts
  invoice_item
  livemode
  metadata
  period
  plan
  price
  proration
  quantity
  subscription
  subscription_item
  tax_amounts
  tax_rates
  type
}
    `;
export const StripeLineItemFieldsFragmentDoc = gql`
    fragment StripeLineItemFields on StripeLineItem {
  id
  object
  amount_subtotal
  amount_discount
  amount_tax
  amount_total
  currency
  description
  discounts
  price {
    ...StripePriceFields
  }
  quantity
  taxes
}
    ${StripePriceFieldsFragmentDoc}`;
export const StripeQuoteFieldsFragmentDoc = gql`
    fragment StripeQuoteFields on StripeQuote {
  id
  object
  amount_subtotal
  amount_total
  application
  application_fee_amount
  application_fee_percent
  collection_method
  created
  currency
  customer
  default_tax_rates
  description
  discounts
  expires_at
  footer
  from_quote
  header
  invoice
  invoice_settings
  livemode
  metadata
  number
  on_behalf_of
  status
  status_transitions
  subscription
  subscription_data
  subscription_schedule
  total_details {
    amount_discount
    amount_tax
  }
  transfer_data
  line_items {
    object
    data {
      ...StripeLineItemFields
    }
    has_more
  }
}
    ${StripeLineItemFieldsFragmentDoc}`;
export const StripePmCardFieldsFragmentDoc = gql`
    fragment StripePmCardFields on StripePmCard {
  brand
  checks
  country
  description
  display_brand
  exp_month
  exp_year
  fingerprint
  funding
  iin
  issuer
  last4
  networks
  three_d_secure_usage
  wallet
}
    `;
export const StripePaymentMethodFieldsFragmentDoc = gql`
    fragment StripePaymentMethodFields on StripePaymentMethod {
  id
  object
  billing_details
  created
  customer
  livemode
  metadata
  type
}
    `;
export const StripeCheckoutSessionFieldsFragmentDoc = gql`
    fragment StripeCheckoutSessionFields on StripeCheckoutSession {
  id
  object
  allow_promotion_codes
  amount_subtotal
  amount_total
  billing_address_collection
  cancel_url
  client_reference_id
  currency
  customer
  customer_details
  customer_email
  line_items
  livemode
  locale
  metadata
  mode
  payment_intent
  payment_method_options
  payment_method_types
  payment_status
  setup_intent
  shipping_address_collection
  submit_type
  subscription
  success_url
  total_details
}
    `;
export const StripeProductFieldsFragmentDoc = gql`
    fragment StripeProductFields on StripeProduct {
  id
  type
  object
  active
  attributes
  caption
  created
  deactivate_on
  description
  images
  livemode
  metadata
  name
  package_dimensions
  shippable
  statement_descriptor
  unit_label
  updated
  url
}
    `;